import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './Chats.module.scss';
import FaqRedirectionPage from './FaqRedirectionPage';
import CreatedTicketPage from './CreatedTicketPage';
import { clickTracker, linksObj } from '../../lib/common';

const TicketCreateRespPage = ({
  ticketCreateResp,
  subIssuesArr,
  setSelectedSubIssue,
  selectedIssueVal,
  loading,
  subIssuesObj,
  setShowOthersAttchments,
}) => {
  const [specifyMore, setSpecifyMore] = useState('');
  const hasFaqPage = Object.keys(linksObj).includes(selectedIssueVal);
  return (
    <div className="p-20">
      <CreatedTicketPage
        loading={loading}
        ticketCreateResp={ticketCreateResp}
        selectedIssueVal={selectedIssueVal}
        pageType=""
      />
      {!specifyMore && (
        <div className={`${styles.ExecutiveBox} mb-20`}>
          <div className={`${styles.TextBox}`}>
            <div className={`${styles.ExecutiveIcon} csicon`} />
            <div className={`${styles.ChatText} font14 fw500 color111`}>
              Do you want to specify/edit your concern?
              <div className={`${styles.ExecutiveBtnGroup}`}>
                {['No, Thanks', 'Yes'].map((each, idx) => (
                  <button
                    key={idx}
                    onClick={() => {
                      if (selectedIssueVal === 'Others' && each === 'Yes') {
                        setShowOthersAttchments(true);
                      } else {
                        setSpecifyMore(each === 'Yes' ? 'yes' : 'no');
                        if (each === 'Yes') {
                          clickTracker('edit_ticket', 'Yes');
                        } else {
                          clickTracker('edit_ticket', 'No');
                        }
                      }
                    }}
                    type="button"
                    className={`${styles.ExecutiveButton} ${idx === 0 ? 'blue_whitefill_animate' : 'bluefill_animate'} `}
                  >
                    <div className={`font13 fw600 ${idx === 0 ? 'color007' : 'colorFFF'}`}>{each}</div>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
      {specifyMore === 'no' && hasFaqPage && <FaqRedirectionPage selectedIssueVal={selectedIssueVal} />}
      {specifyMore === 'yes' && (
        <div className={`${styles.ExecutiveBox} mb-20`}>
          <div className={`${styles.TextBox}`}>
            <div className={`${styles.ExecutiveIcon} csicon`} />
            <div className={`${styles.ChatText}`}>
              <div className="font14 fw500 color111">Please select your query</div>

              <div className={`${styles.SeachResult} `}>
                <ul className={`${styles.ResultList}`}>
                  {subIssuesArr &&
                    subIssuesArr?.length > 0 &&
                    subIssuesArr?.map((each, idx) => (
                      <li key={idx}>
                        <div
                          className={`${styles.ResultItem}`}
                          tabIndex={0}
                          role="button"
                          onKeyDown={() => {}}
                          onClick={async () => {
                            const rawLabel = subIssuesObj?.[each];
                            const label = `update_${rawLabel.replace(/\s+/g, '')}`;
                            await clickTracker(label, 'edit_ticket');
                            setSelectedSubIssue(each);
                          }}
                        >
                          <div className={`${styles.ResultTxt}`}>
                            <div className="font14 fw500 color111">{each}</div>
                          </div>
                          <div className={`${styles.ChevronRgt} csicon`} />
                        </div>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TicketCreateRespPage;
TicketCreateRespPage.propTypes = {
  ticketCreateResp: PropTypes.object,
  subIssuesArr: PropTypes.array,
  setSelectedSubIssue: PropTypes.func,
  selectedIssueVal: PropTypes.string,
  loading: PropTypes.bool,
  subIssuesObj: PropTypes.object,
  setShowOthersAttchments: PropTypes.func,
};
